/* Grounded Connections — live moon dates (Meeus, Astronomical Algorithms ch. 49). Accurate to a few minutes. */
(function (root) {
  var R = Math.PI / 180;
  function jdToDate(jd) { return new Date((jd - 2440587.5) * 86400000); }
  function phaseJD(k) { // k integer = new moon, k + 0.5 = full moon
    var T = k / 1236.85, T2 = T * T, T3 = T2 * T, T4 = T3 * T;
    var jde = 2451550.09766 + 29.530588861 * k + 0.00015437 * T2 - 0.00000015 * T3 + 0.00000000073 * T4;
    var E = 1 - 0.002516 * T - 0.0000074 * T2;
    var M = (2.5534 + 29.1053567 * k - 0.0000014 * T2 - 0.00000011 * T3) * R;
    var Mp = (201.5643 + 385.81693528 * k + 0.0107582 * T2 + 0.00001238 * T3 - 0.000000058 * T4) * R;
    var F = (160.7108 + 390.67050284 * k - 0.0016118 * T2 - 0.00000227 * T3 + 0.000000011 * T4) * R;
    var Om = (124.7746 - 1.56375588 * k + 0.0020672 * T2 + 0.00000215 * T3) * R;
    var full = Math.abs(k % 1) > 0.25;
    var c = full
      ? -0.40614 * Math.sin(Mp) + 0.17302 * E * Math.sin(M) + 0.01614 * Math.sin(2 * Mp) + 0.01043 * Math.sin(2 * F)
      : -0.4072 * Math.sin(Mp) + 0.17241 * E * Math.sin(M) + 0.01608 * Math.sin(2 * Mp) + 0.01039 * Math.sin(2 * F);
    c += (full ? 0.00734 : 0.00739) * E * Math.sin(Mp - M) - (full ? 0.00515 : 0.00514) * E * Math.sin(Mp + M)
      + (full ? 0.00209 : 0.00208) * E * E * Math.sin(2 * M) - 0.00111 * Math.sin(Mp - 2 * F) - 0.00057 * Math.sin(Mp + 2 * F)
      + 0.00056 * E * Math.sin(2 * Mp + M) - 0.00042 * Math.sin(3 * Mp) + 0.00042 * E * Math.sin(M + 2 * F)
      + 0.00038 * E * Math.sin(M - 2 * F) - 0.00024 * E * Math.sin(2 * Mp - M) - 0.00017 * Math.sin(Om);
    return jdToDate(jde + c - 69 / 86400);
  }
  function kNear(d) { return Math.floor(((d.getTime() / 86400000 + 2440587.5) - 2451550.09766) / 29.530588861); }
  // next new (offset 0) or full (offset 0.5) moon on or after `from`, compared by UK calendar day
  function next(offset, from) {
    from = from || new Date();
    var today = ukDay(from);
    for (var k = kNear(from) - 1; ; k++) {
      var d = phaseJD(k + offset);
      if (ukDay(d) >= today) return d;
    }
  }
  function ukParts(d) {
    var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    return p;
  }
  function ukDay(d) { var p = ukParts(d); return Date.UTC(+p.year, +p.month - 1, +p.day) / 86400000; }
  function daysUntil(d, from) { return ukDay(d) - ukDay(from || new Date()); }
  function fmt(d, opts) { opts = opts || {}; opts.timeZone = 'Europe/London'; return new Intl.DateTimeFormat('en-GB', opts).format(d); }
  // 0 new, 1 waxing crescent, 2 first quarter, 3 waxing gibbous, 4 full, 5 waning gibbous, 6 last quarter, 7 waning crescent
  var NAMES = ['New Moon', 'Waxing Crescent', 'First Quarter', 'Waxing Gibbous', 'Full Moon', 'Waning Gibbous', 'Last Quarter', 'Waning Crescent'];
  function phaseIndex(now) {
    now = now || new Date();
    var k = kNear(now) - 1, a = phaseJD(k), b;
    while ((b = phaseJD(k + 1)) <= now) { k++; a = b; }
    var days = (now - a) / 86400000, len = (b - a) / 86400000, q = len / 4;
    // each principal phase owns roughly one day either side of its instant
    var marks = [0, q, 2 * q, 3 * q, len];
    for (var i = 0; i < marks.length; i++) if (Math.abs(days - marks[i]) <= 1) return (i * 2) % 8;
    return Math.floor(days / q) * 2 + 1;
  }
  root.GCMoon = { next: next, daysUntil: daysUntil, fmt: fmt, phaseIndex: phaseIndex, NAMES: NAMES };
})(window);
